(function (){
    'use strict';

    angular
        .module('app')
        .directive('jvectorMap', jvectorMap);

    jvectorMap.$inject =  ['$timeout', '$filter'];

    function jvectorMap ($timeout, $filter) {
        return {
            restrict: 'AE',
            templateUrl: 'templates/directives/jvectormap/view/jvectorMap.html',
            replace:true,
            require: 'ngModel',
            link:function (scope, element, attrs, ngModel) {
                scope.$watch('ngModel',function(item) {
                    var gdpData = ngModel.$viewValue;
                    return element.vectorMap({
                        map: 'world_merc_en',
                        backgroundColor: '#ffffff',
                        zoomOnScroll: false,
                        regionStyle: {
                            initial: {
                                fill: '#e1e1e1',
                                stroke: 'none',
                                "stroke-width": 0,
                                "stroke-opacity": 1
                            },
                            hover: {
                                "fill-opacity": 0.8
                            },
                            selected: {
                                fill: '#8dc859'
                            },
                            selectedHover: {
                            }
                        },
                        markerStyle: {
                            initial: {
                                fill: '#e84e40',
                                stroke: '#e84e40'
                            }
                        },
                        series: {
                            regions: [{
                                values: gdpData,
                                scale: ['#6fc4fe', '#2980b9'],
                                normalizeFunction: 'polynomial'
                            }]
                        },
                        onRegionLabelShow: function(e, el, code){
                            el.html(el.html()+' ('+gdpData[code]+')');
                        }
                    });
                });

            }
        }
    }

})();
